var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('Topbar'),_c('Sidebar',{attrs:{"is-condensed":_vm.isMenuCondensed,"type":'light',"width":'fluid'}}),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_c('Footer')],1),_c('ModalLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }